"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createAvatarStyle;

function createAvatarStyle(_ref) {
  var avatarBorderRadius = _ref.avatarBorderRadius,
      avatarSize = _ref.avatarSize;
  return {
    '&.webchat__defaultAvatar': {
      borderRadius: avatarBorderRadius,
      height: avatarSize,
      width: avatarSize
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJjcmVhdGVBdmF0YXJTdHlsZSIsImF2YXRhckJvcmRlclJhZGl1cyIsImF2YXRhclNpemUiLCJib3JkZXJSYWRpdXMiLCJoZWlnaHQiLCJ3aWR0aCJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL1N0eWxlcy9TdHlsZVNldC9BdmF0YXIudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgU3RyaWN0U3R5bGVPcHRpb25zIH0gZnJvbSAnYm90ZnJhbWV3b3JrLXdlYmNoYXQtYXBpJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gY3JlYXRlQXZhdGFyU3R5bGUoeyBhdmF0YXJCb3JkZXJSYWRpdXMsIGF2YXRhclNpemUgfTogU3RyaWN0U3R5bGVPcHRpb25zKSB7XG4gIHJldHVybiB7XG4gICAgJyYud2ViY2hhdF9fZGVmYXVsdEF2YXRhcic6IHtcbiAgICAgIGJvcmRlclJhZGl1czogYXZhdGFyQm9yZGVyUmFkaXVzLFxuICAgICAgaGVpZ2h0OiBhdmF0YXJTaXplLFxuICAgICAgd2lkdGg6IGF2YXRhclNpemVcbiAgICB9XG4gIH07XG59XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFFZSxTQUFTQSxpQkFBVCxPQUFtRjtFQUFBLElBQXREQyxrQkFBc0QsUUFBdERBLGtCQUFzRDtFQUFBLElBQWxDQyxVQUFrQyxRQUFsQ0EsVUFBa0M7RUFDaEcsT0FBTztJQUNMLDRCQUE0QjtNQUMxQkMsWUFBWSxFQUFFRixrQkFEWTtNQUUxQkcsTUFBTSxFQUFFRixVQUZrQjtNQUcxQkcsS0FBSyxFQUFFSDtJQUhtQjtFQUR2QixDQUFQO0FBT0QifQ==